/* tslint:disable */
/* eslint-disable */
/**
 * DAM PORTAL API
 * API for handling DAM PORTAL operations.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetField,
    AssetFieldFromJSON,
    AssetFieldFromJSONTyped,
    AssetFieldToJSON,
} from './AssetField';

/**
 * DAM Asset
 * @export
 * @interface Asset
 */
export interface Asset {
    /**
     * Asset id
     * @type {number}
     * @memberof Asset
     */
    id: number;
    /**
     * Asset type
     * @type {string}
     * @memberof Asset
     */
    type: string;
    /**
     * Asset file name
     * @type {string}
     * @memberof Asset
     */
    name: string;
    /**
     * Asset extension
     * @type {string}
     * @memberof Asset
     */
    extension: string;
    /**
     * List of custom asset fields, only added, when asset endpoint is used.
     * @type {Array<AssetField>}
     * @memberof Asset
     */
    fields?: Array<AssetField>;
}

export function AssetFromJSON(json: any): Asset {
    return AssetFromJSONTyped(json, false);
}

export function AssetFromJSONTyped(json: any, ignoreDiscriminator: boolean): Asset {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'name': json['name'],
        'extension': json['extension'],
        'fields': !exists(json, 'fields') ? undefined : ((json['fields'] as Array<any>).map(AssetFieldFromJSON)),
    };
}

export function AssetToJSON(value?: Asset | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': value.type,
        'name': value.name,
        'extension': value.extension,
        'fields': value.fields === undefined ? undefined : ((value.fields as Array<any>).map(AssetFieldToJSON)),
    };
}

